module.exports = __webpack_public_path__ + "static/security-5565df57817724f7ce89a7d06c978520.jpg";